import type { AdminUser } from "@glow-price/shared";

const TOKEN_KEY = "glow_admin_token";
const USER_KEY = "glow_admin_user";
const ADMIN_KEY = "glow_admin_me";

export type AdminSessionUser = {
  username: string;
  displayName: string | null;
};

const listeners = new Set<() => void>();
function notify() {
  for (const l of listeners) l();
}

export function subscribeAuth(cb: () => void): () => void {
  listeners.add(cb);
  return () => {
    listeners.delete(cb);
  };
}

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function getSessionUser(): AdminSessionUser | null {
  const raw = localStorage.getItem(USER_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as AdminSessionUser;
  } catch {
    return null;
  }
}

/**
 * Phase 6D-1 — full safe AdminUser cache. We fetch /api/admin/auth/me once
 * after login and cache the result so RoleGuard / menu visibility / page
 * controls can render synchronously. Cleared on logout / 401.
 */
export function getCurrentAdmin(): AdminUser | null {
  const raw = localStorage.getItem(ADMIN_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as AdminUser;
  } catch {
    return null;
  }
}

export function setCurrentAdmin(admin: AdminUser | null): void {
  if (admin) {
    localStorage.setItem(ADMIN_KEY, JSON.stringify(admin));
  } else {
    localStorage.removeItem(ADMIN_KEY);
  }
  notify();
}

export function setSession(token: string, user: AdminSessionUser): void {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(USER_KEY, JSON.stringify(user));
  notify();
}

export function clearSession(): void {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
  localStorage.removeItem(ADMIN_KEY);
  notify();
}
